import script from "./Tabbar.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./Tabbar.vue?vue&type=script&setup=true&async=true&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=50ca816e&lang=scss&scoped=true"

import exportComponent from "H:\\360MoveData\\Users\\xw\\Desktop\\work\\2022\\2月\\南山网飞卡\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ca816e"]])

export default __exports__